<template>
  <div class="bg-white rounded-lg shadow-md p-6 h-full flex flex-col justify-between">
    <div>
      <h3 class="text-lg font-semibold text-gray-700 mb-4">Estado del Bono</h3>
      
      <!-- Período -->
      <div v-if="periodo" class="mb-4 text-center">
        <p class="text-sm text-gray-500">Período</p>
        <p class="text-xl font-bold text-gray-800">{{ periodo.mes_nombre }} {{ periodo.anio }}</p>
      </div>

      <!-- Icono y Estado -->
      <div class="text-center mb-6">
        <div v-if="resultado" class="inline-flex flex-col items-center">
          <!-- Icono -->
          <div :class="iconoClases" class="mb-4">
            <svg v-if="resultado.bono_ganado" class="w-20 h-20" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <svg v-else class="w-20 h-20" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
          </div>

          <!-- Estado -->
          <div :class="estadoClases" class="px-6 py-3 rounded-full text-lg font-bold mb-2">
            {{ resultado.bono_ganado ? '✅ BONO GANADO' : '❌ BONO PERDIDO' }}
          </div>
        </div>
      </div>

      <!-- Monto -->
      <div v-if="resultado" class="text-center mb-4">
        <p class="text-sm text-gray-500 mb-1">Monto del Bono</p>
        <p :class="montoClases" class="text-4xl font-bold">
          ${{ resultado.monto_bono.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
        </p>
      </div>

      <!-- Mensaje -->
      <div v-if="resultado" class="bg-gray-50 rounded-lg p-4">
        <p class="text-sm text-gray-700 text-center">{{ resultado.mensaje }}</p>
      </div>
    </div>

    <!-- Info adicional -->
    <div class="mt-6 pt-4 border-t border-gray-200">
      <div class="flex items-center justify-center text-xs text-gray-500">
        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <span>Bono aplicable a instalaciones (grupal)</span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'EstadoBono',
  props: {
    resultado: {
      type: Object,
      default: null,
    },
    periodo: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const iconoClases = computed(() => {
      return props.resultado?.bono_ganado 
        ? 'text-green-500' 
        : 'text-red-500';
    });

    const estadoClases = computed(() => {
      return props.resultado?.bono_ganado
        ? 'bg-green-100 text-green-800'
        : 'bg-red-100 text-red-800';
    });

    const montoClases = computed(() => {
      return props.resultado?.bono_ganado
        ? 'text-green-600'
        : 'text-red-600';
    });

    return {
      iconoClases,
      estadoClases,
      montoClases,
    };
  },
};
</script>
